import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const fields = [
            'dg',
            'rep1',
            'rep2',
            'rep3',
            'comm'
        ];

        fields.forEach((field) => {
            const nom = this.el.querySelector(`input[name="${field}-nom"]`);
            const mobile = this.el.querySelector(`input[name="${field}-mobile"]`);

            // Set the value of the input fields from local storage
            nom.value = localStorage.getItem(`${field}Nom`) || '';
            mobile.value = localStorage.getItem(`${field}Mobile`) || '';

            // Add event listeners to save the values to local storage on change
            nom.addEventListener('change', () => {
                localStorage.setItem(`${field}Nom`, nom.value);
                const label = this.el.querySelector(`.${field}-nom`);
                if (label) {
                    label.innerHTML = nom.value;
                }
            });
            mobile.addEventListener('change', () => {
                localStorage.setItem(`${field}Mobile`, mobile.value);
                const link = this.el.querySelector(`.${field}-mobile`);
                if (link) {
                    let href = mobile.value;
                    href = href.replace(/[^0-9]/g, '');
                    href = 'tel:' + href;
                    link.setAttribute('href', href);
                    link.innerHTML = mobile.value;
                    if (mobile.value) {
                        link.classList.remove('hidden');
                    } else {
                        link.classList.add('hidden');
                    }
                } else {
                    link.classList.add('hidden');
                }
            });

            // set the label and link values on page load
            const label = this.el.querySelector(`.${field}-nom`);
            if (label) {
                label.innerHTML = nom.value;
            }
            const link = this.el.querySelector(`.${field}-mobile`);
            if (link) {
                let href = mobile.value;
                href = href.replace(/[^0-9]/g, '');
                href = 'tel:' + href;
                link.setAttribute('href', href);
                link.innerHTML = mobile.value;
                if (mobile.value) {
                    link.classList.remove('hidden');
                } else {
                    link.classList.add('hidden');
                }
            } else {
                link.classList.add('hidden');
            }
        });
    }
}
